import Vue from 'vue'

import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import { Quasar, Dialog, Notify } from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: { /* not needed if importStrategy is not 'manual' */ },
  directives: { /* not needed if importStrategy is not 'manual' */ },
  plugins: {
    Dialog,
    Notify
  }
})

// 全局通知默认从顶部弹出（Quasar 默认是 bottom，从下往上）
// 用 setDefaults 绕开 Vue.use(Quasar) 双重注册导致 config.notify 不生效的问题
Notify.setDefaults({ position: 'top' })
